module.exports = "<div class=row> </div> <div class=container-fluid> <div class=row-fluid> <div class=col-lg-12> <div class=\"centering text-center error-container\"> <div class=text-center> <h2 class=without-margin>Lo Sentimos , no tiene <span class=text-warning><big>Permisos</big></span> para este módulo</h2> <h4 class=text-warning>Acceso Denegado</h4> </div> <div class=text-center> <h3><small>Contactese con el administrador del sistema para poder acceder a esta función.</small></h3> </div> <hr> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/unauthorized/unauthorized.html
// module id = 178
// module chunks = 0